export default "__VITE_ASSET__BDX$fS2J__"